/**
 * 入札一覧まわりの「見出し帯」の高さ。
 *
 * 2 カラム (左 = フィルターサイドバー / 右 = 入札一覧) の**見出しの下線が横一直線に
 * つながる**ことが design の意図なので、左右で同じ値を使う。design も
 * `spot.html:1254` で「header 高さを sidebar-section-title と中間値 56px に統一」と
 * 明記している。
 *
 * **左右で別々に 56px を書かない。** 2026-08-31 のデザイナー指摘 (preview で
 * 「見出しの下線が数 px ズレている」) は、左を `min-height: 56px` で固定する一方、
 * 右は中身 (ボタン 40px + 縦 padding 8px) がたまたま 56px になるのに任せていたのが
 * 原因。右の中身が 40px を超えた瞬間に右だけ伸びて下線がズレる。
 *
 * design 側も同じ弱さを持つ (`.ecl-accordion-trigger` は padding だけで
 * height 指定が無い) が、実装では**高さを確定させて中身を合わせる**方向に倒す。
 * そのため:
 *
 * - 器は `minHeight` ではなく `height` でこの値に固定する
 * - 帯に置くボタンは `size="md"` (= 40px) を**明示**する。size 未指定で DS 既定に
 *   任せると、DS 側の既定が変わった時に器を突き破る
 */
export const LIST_HEADER_HEIGHT = '56px'
